<template>
  <van-popup
      position="bottom"
      round
      closeable
      @close="closeModal"
      class="select-yongliao-modal"
      :style="{ 'height': '90%','overflow':'hidden'}"
      v-model="modalShow"
  >
    <div class="tit">点击选择用料</div>
    <van-search v-model="keyword" @search="onSearch" placeholder="请输入搜索关键词"/>

    <van-list
        v-model="loading"
        class="body_list"
        :finished="finished"
        finished-text="没有更多了"
    >

      <van-cell-group v-for="(items,index) in productlist" :key="index" :title="items.seriesName">
        <van-grid :border="false" :column-num="4">
          <van-grid-item @click="selectItem(item)" :class="['item',{'active':item.active}]" :key="item.id" v-for="item in items.products">
            <van-image class="item" fit="contain" lazy-load position="center" :src="item.colorImageUrl || item.curtainImageUrl1" />
<!--            <img :src="item.colorImageUrl || item.curtainImageUrl1"/>-->
            <span class="title">{{ item.number }}</span>
          </van-grid-item>

<!--          <van-grid-item v-for="item in 8" :key="item" :src="item.colorImageUrl || item.curtainImageUrl1"  :text="item.number" />-->
        </van-grid>
      </van-cell-group>

<!--      <van-cell v-for="item in productlist" :key="item" :title="item.seriesName" />

      <div v-for="items in productlist">
        <div class="seriesName">{{ items.seriesName }}</div>-->

<!--        <div class="list">
          <div @click="selectItem(item)" :class="['item',{'active':item.active}]" :key="item.id" v-for="item in items.products">
            <img :src="item.colorImageUrl || item.curtainImageUrl1"/>
            <span class="title">{{ item.number }}</span>
          </div>
        </div>-->
<!--      </div>-->

    </van-list>

    <!-- <van-button @click="confirmSelectZhuBuAction" color="#f24749" type="primary" block>确认选择</van-button> -->
  </van-popup>
</template>
<script >
export default {
  name:'ChooseYongliao',
  props: {

    list:{
     type:Array,
      required: true,
      default: false,
    },
    modalShow: {
      type: Boolean,
      required: true,
      default: false,
    },
  },

  data() {
    return {
      loading: false,
      finished: false,
      keyword:"",
      zhubu:"",
      productlist:"",
    };
  },
  mounted() {
    this.keyword = ""
  },
  methods : {
    onSearch(){
      this.$emit("searchYongLiao",this.keyword)
    },
    confirmSelectYongLiaoAction(){
       this.$emit("confirmSelectYongLiao")
    },
    closeModal(){
      this.$parent.showYongLiaoModal = false

    },
    selectItem(item){
        this.$emit("selYongLiao",item)
         this.$parent.showYongLiaoModal = false
    }
  }
};
</script >
<style scoped>
.select-yongliao-modal .van-search {
  margin-top: 40px;
}

.select-yongliao-modal .tit {
  text-align: center;
  position: absolute;
  padding-top: 15px;
  width: 100%;
  font-size: 14px;

}

.select-yongliao-modal .body_list {
  flex-wrap: wrap;
  align-content: flex-start;
  height: calc(90vh - 138px);
  overflow-y: auto;
  padding-bottom: 40px;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  width: 100%;
}

.select-yongliao-modal .body_list .item {
  flex: 0 0 calc(25vw - 15px);
  height: calc(25vw - 15px);
  overflow: hidden;
  position: relative;
  box-sizing: border-box;
  margin-bottom: 5px;
  /*padding: 2px 5px;*/
  /*border: 1px solid #f1f1f1;*/
}
.select-yongliao-modal .body_list .item .title {
  /*position: absolute;
  bottom: 0;
  width: 100%;
  text-align: center;
  !*left: 0;*!
  background: rgba(118, 115, 115, 0.5);
  padding: 2px 5px;
  font-size: 12px;
  color: #F2F2F2;*/
  position: absolute;
  bottom: 3px;
  width: 83%;
  text-align: center;
  background: rgba(118, 115, 115, 0.5);
  padding: 3px 0px;
  font-size: 12px;
  color: #FFFFFF;
}
/*
.select-yongliao-modal .list .item {
  flex: 0 0 calc(25vw - 15px);
  margin-bottom: 10px;
  padding: 10px;
  max-height: calc(25vw - 15px);
  overflow: hidden;
  position: relative;
  box-sizing: border-box;
  border: 1px solid #f1f1f1;
  margin: 0 10px 0 0;

}

.select-yongliao-modal .list .item.active {
  border: 1px solid #f0494e59 !important;
}

.select-yongliao-modal .list .item:nth-child(2n+4) {
  margin-right: 0;
}

.select-yongliao-modal .list .item img {
  max-width: 100%;
}

.select-yongliao-modal .list .title {
  position: absolute;
  bottom: 0;
  width: 100%;
  text-align: center;
  left: 0;
  background: #f1f1f1c4;
  padding: 2px 5px;
  font-size: 12px;
}*/
/*
.select-yongliao-modal .seriesName {
  padding: 10px;
  margin: 0;
  display: block;
  width: 100%;
}

.select-yongliao-modal .list {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -ms-flex-wrap: wrap;
  flex-wrap: wrap;
  -ms-flex-line-pack: start;
  align-content: flex-start;

  !*height: calc(90vh - 138px);*!
  !*overflow-y: auto;*!
  !*padding-bottom: 40px;*!
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  !*margin-left: 15px;*!
}

.select-yongliao-modal .list .item {
  flex: 0 0 calc(25vw - 15px);
  margin-bottom: 10px;
  padding: 10px;
  max-height: calc(25vw - 15px);
  overflow: hidden;
  position: relative;
  box-sizing: border-box;
  border: 1px solid #f1f1f1;
  margin: 0 10px 0 0;

}

.select-yongliao-modal .list .item.active {
  border: 1px solid #f0494e59 !important;
}

.select-yongliao-modal .list .item:nth-child(2n+4) {
  margin-right: 0;
}

.select-yongliao-modal .list .item img {
  max-width: 100%;
}

.select-yongliao-modal .list .title {
  position: absolute;
  bottom: 0;
  width: 100%;
  text-align: center;
  left: 0;
  background: #f1f1f1c4;
  padding: 2px 5px;
  font-size: 12px;
}*/
</style>
